import { getAllUniteRegionalesSaga } from './getAllUniteRegionales'
import { addUniteRegionaleSaga } from './addUniteRegionale'
import { editUniteRegionaleSaga } from './editUniteRegionale'
import { deleteUniteRegionaleSaga } from './deleteUniteRegionale'

const uniteRegionaleSagas = [
    getAllUniteRegionalesSaga,
    addUniteRegionaleSaga,
    editUniteRegionaleSaga,
    deleteUniteRegionaleSaga,
]

export default uniteRegionaleSagas
